import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    marginTop: "15px",
    width: "100%"
  },
  alert: {
    display: "grid",
    width: "100%"
  },

  item: {
    padding: "0 0.8rem 0 0.8rem",
    marginTop: "5px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    margin: "0.1rem"
  },
  infoTitle: {
    fontSize: "0.8125rem",
    color: "#29132e",
    fontFamily: "Roboto",
    marginRight: "1rem",
    width: 70,
    textAlign: "end"
  },
  info: {
    fontSize: "0.8125rem",
    color: "#545964",
    fontFamily: "RobotoMedium",
    marginRight: "1rem"
  },
  button: {
    backgroundColor: "white",
    color: "rgba(41, 19, 46, 0.95)",
    marginTop: 12
  },
  itemButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  ulContainer: {
    display: "flex",
    width: "100%",
    minHeight: "180px"
  },
  descriptionText: {
    overflow: "hidden",
    width: "200px",
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical"
  }
});
export default useStyles;
